<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn icon class="mx-0" @click="edit(name,email,phone,gender,username,rights,campus)">
                      <v-icon color="teal">edit</v-icon>
           </v-btn>
           
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>EDIT YOUR DETAILS</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="editform"> 
                     <v-text-field label="Username*" v-model="usernameloc"   @keypress="isName" :rules="usernameRules" prepend-icon="person"></v-text-field>
                     <v-text-field label="Password*" v-model="password" :rules="passRules" prepend-icon="lock"></v-text-field>
                     <v-text-field label="Full Name*" v-model="nameloc" :rules="nameRules" prepend-icon="comment"></v-text-field>
                     <v-text-field label="Email Address" v-model="emailloc" prepend-icon="mail"></v-text-field>
                     <v-text-field label="Phone number" v-model="phoneloc"   @keypress="isNumber" prepend-icon="phone"></v-text-field>
                     <v-select label="Gender*" item-text="gender" :items="[{header:'Gender'},'male','female']" v-model="genderloc"  prepend-icon="contacts"></v-select>
                     <v-select v-if="crc(staff.rights,'013')" label="Campus*" item-text="campus" :items="camp" v-model="campusloc"  prepend-icon="contacts"></v-select>
                    
                     <v-select v-if="crc(staff.rights,'013')" label="Rights*" item-text="rights" multiple :items="roles" v-model="rightsloc"  prepend-icon="contacts"></v-select>
                    <span v-if="error_state" class="red--text">{{error_value}}</span>
                    <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled" >Edit </v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {editModule} from '@/model';
import moment from 'moment';
import {checkright,loadCampus} from '@/validator'


export default {
    name: 'EditStaff',
    props:{
        username :{
            required:true
        },
        email:{
            required:true
        },
        name:{
            required:true
        },
        phone:{
            required:true
        },
        campus:{
             required:true
        },
        gender:{
             required:true
        },
        rights:{
            required:true
        }

    },computed:{
            usernameloc :{
                 get:function(){
                     return this.usernameda;
                 },
                 set:function(user){
                      this.usernameda = user
                 }
                 },
            nameloc:{
                 
                get:function(){
                     return this.nameda;
                 },
                 set:function(name){
                      this.nameda = name
                 }
                 
                 
                 },
                 emailloc:{
                 
                get:function(){
                     return this.emailda;
                 },
                 set:function(email){
                      this.emailda = email
                 }
                 
                 
                 },
                 phoneloc:{
                 get:function(){
                     return this.phoneda;
                 },
                 set:function(phone){
                      this.phoneda = phone
                 }
                     
                 },
                 campusloc:{
                 get:function(){
                     return this.campusda;
                 },
                 set:function(campus){
                      this.campusda = campus
                 }
                     
                 },
                 genderloc:{
                 get:function(){
                     return this.genderda;
                 },
                 set:function(gender){
                      this.genderda = gender
                 }
                     
                 },
                 rightsloc:{
                 get:function(){
                     return this.rightsda;
                 },
                 set:function(rights){
                      this.rightsda = rights
                 }
                     
                 }

      
    },
    data() {
        return {
            isDisabled:false,
            staff:this.$store.getters.getStaff,
            usernameda:this.username,
            nameda:this.name,
            emailda:this.email,
            phoneda:this.phone,
            password:'',
            campusda:this.campus,
            genderda:this.gender,
            error_state:false,
            error_value:'You must supply a gender',
            camp:loadCampus([{header:'Supers'},'all',{header:'Normal'}],this.$store.getters.getCampus),
            rightsda:this.rights,
            roles:[
             {header:'Super'},
              '003','007','011','012','013','014','015','018',
              {header:'Average'},
              '001','002','004','005','008','009','016','017','019','020','022','023',
              {header:'Normal'},
              '006','010','021'
             ],
         
            usernameRules:[
               v => v.length >=5  || "Minimum length is 5 characters",
               v => v.length <=20  || "Maximum length is 20 characters",
               
           ],
        passRules:[
               v => v.length >=4  || "Minimum length is 4 characters",
               v => v.length <=20  || "Maximum length is 20 characters" 
           ],
        nameRules:[
               v => v.length >=5  || "Minimum length is 5 characters",
               v => v.length <=30  || "Maximum length is 30 characters" 
           ]


        };
    },
    methods: {
         edit(name,email,phone,gender,username,rights,campus){
            this.usernameda = username;
            this.nameda = name;
            this.emailda  = email;
            this.phoneda = phone;
            this.campusda = campus;
            this.genderda = gender;
            this.rightsda = rights;
            
        },
        crc(array,value){
      return checkright(array,value);
        },

        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if(charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        isNumber:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) || charcode == 46){
                evt.preventDefault();
            }else{
                return true;
            }
        },
        add() {
            let self=this;
            if(this.$refs.editform.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            
            if(this.campusda.length==0){
                    self.error_state = true;
                    self.error_value = "Staff must be assigned a campus"
                    return
            }else if(this.genderda.length==0){
                    self.error_state = true;
                    self.error_value = "Staff must be assigned a gender"
                    return
            }else{
                if(this.rights.length==0){
                    self.error_state = true;
                    self.error_value = "Staff must be assigned at least one right"
                    return
                }
            }
            
            self.error_state = false;
            let useradd = this.$store.getters.getStaff.name;
            let newitem = {name:this.usernameda.toLowerCase(),password:this.password,fullname:this.nameda,campus:this.campusda.toLowerCase(),gender:this.genderda,email:this.emailda,phone_no:this.phoneda,rights:this.rightsda,dateadded:datenow,useredit:useradd};
            console.log(newitem);
            self.isDisabled = true;
            editModule('staff',this.username,this.usernameloc,newitem,function(response){
              if(response){
                    console.log("This is response: ",response);
                     alert('Staff has been successfully updated');
                    self.$store.dispatch('updateStaffs');
                    self.isDisabled = false;
                    //this will prevent the replacement of current user with edited user due to super privilege
                    if(self.staff.name == self.username){
                        self.$store.commit('changeStaff', newitem);
                    }
                    
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>